$(document).ready(function() {

	$(".upsell-check").click(function(){
     
     	if($(this).prop('checked') == true){
   		 	$('.container_fl_radio').addClass("acitive_bdge_box");
		}
     	else
        {
        	$('.container_fl_radio').removeClass("acitive_bdge_box");
        }
    	   
   	});
  
  	$('[name=packOpt]').click(function(){
      
      	$('.buyOpt-row').removeClass('active');
   		$(this).parent().closest('label').addClass('active');
      
      	let pack_options = $(this).val();
      	
        if(pack_options == "3")
        {
        	$('.prodName').text('3 Pack');
          	$('.best-prc-buy1').hide();
            $(".prodRgt1").attr("src","https://cdn.shopify.com/s/files/1/0300/3180/6597/files/3_tummy_health.png?v=1649689107");
          	$(".no-pilw").text('Perfect For 3+ Dogs');
        }
      	else if(pack_options == "2")
        {
        	$('.prodName').text('2 Pack');
          	$('.best-prc-buy1').show();
            $(".prodRgt1").attr("src","https://cdn.shopify.com/s/files/1/0300/3180/6597/files/2_tummy_health.png?v=1649689107");
            $(".no-pilw").text('Perfect For 2 Dogs');
        }
      	else
        {
        	$('.prodName').text('1 Pack');
            $('.best-prc-buy1').hide();
            $(".prodRgt1").attr("src","https://cdn.shopify.com/s/files/1/0300/3180/6597/files/1_tummy_heath.png?v=1649689107");
            $(".no-pilw").text('Perfect For 1 Dogs');
        }  
   		
   	});
  
  
    $('[name=packsize]').click(function(){

		var packsize = $(this).val();
      
      	//alert(packsize);
      
      	if(packsize == "one_time")
        {
        	$('.save_price_3').text('53');
          	$('.save_price_2').text('38');
          	$('.save_price_1').text('22');
          
          	$('.price_each3').text('$32.00/ea');
          	$('.price_each2').text('$35.00/ea');
          	$('.price_each1').text('$40.00/ea');
          
          	$('.only_price3').text('$97.00');
          	$('.only_price2').text('$70.00');
          	$('.only_price1').text('$40.00');
        }
      	else {
        
        	$('.save_price_3').text('75');
          	$('.save_price_2').text('54');
          	$('.save_price_1').text('31');
          
          	$('.price_each3').text('$25.00/ea');
          	$('.price_each2').text('$27.00/ea');
          	$('.price_each1').text('$31.00/ea');
          
          	$('.only_price3').text('$75.00');
          	$('.only_price2').text('$54.00');
          	$('.only_price1').text('$31.00');
        }

    });
  
  $('.buy-now-button').click(function(e) { 
  	
    let purchase_type = $('input[name="packsize"]:checked').val();
    
    var upsell_data_id = $('.upsell-check').attr('data-id');
    
    var upsell_data = {
        "id": upsell_data_id,
        "quantity": 1
    }
    
    if($('.packOpt').is(':checked')) {
      
    	if(purchase_type == "one_time") {
    	
            var main_variant_id = $("input:radio.packOpt:checked").data("id");
          
          	var data = {
              "id": main_variant_id,
              "quantity": 1

            }

            if($('.upsell-check').prop('checked') == true){
				
                $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    data: '',
                    dataType: 'json',
                    success: function() {
                        $.ajax({
                              type: 'POST',
                              url: '/cart/add.js',
                              data: upsell_data,
                              dataType: 'json',
                              success: function() {
                                    $.ajax({
                                    type: 'POST',
                                    url: '/cart/add.js',
                                    data: data,
                                    dataType: 'json',
                                    success: function() {
                                       window.location.href = '/checkout';
                                    }
                                  });
                              }
                            });
                      }
                 });
            }
          	else {
              
                  $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    data: '',
                    dataType: 'json',
                    success: function() {
                        $.ajax({
                              type: 'POST',
                              url: '/cart/add.js',
                              data: data,
                              dataType: 'json',
                              success: function(data) {
                                 window.location.href = '/checkout';
                              }
                            });
                     }
                  }); 
            
      		}

        }
        else {
          
          	var main_variant_id = $("input:radio.packOpt:checked").data("sub");
			var cart_data = {
                "id": main_variant_id,
                "quantity": 1,
                "properties": {
                  "shipping_interval_frequency": 30,
                  "shipping_interval_unit_type": 'Days'
                }
            }
            
            if($('.upsell-check').prop('checked') == true){
        
        
              $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                data: '',
                dataType: 'json',
                success: function() {

                  $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: upsell_data,
                    dataType: 'json',
                    success: function() {
                      //console.log(data);
                        $.ajax({
                          type: "POST",
                          url: '/cart/add.js',
                          data: cart_data,
                          dataType: 'json',
                          success: function() {
                            window.location.href = getCartUrl();
                          }
                        });
                    }
                  });

                 }
              });    


            }
            else{

                  $.ajax({
                      type: "POST",
                      url: '/cart/clear.js',
                      data: '',
                      dataType: 'json',
                      success: function() {
                          $.ajax({
                            type: "POST",
                            url: '/cart/add.js',
                            data: cart_data,
                            dataType: 'json',
                            success: function() {
                              window.location.href = getCartUrl();
                            }
                          });
                      }
                  });  


            }
            
            

        }
    }
    
    else
    {
    	alert("please select a Quantity.");
      	return false;
    }
    
    
  
  });
  
  function getCartUrl() {

      function get_cookie(name){
       return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] 
      }
      do {
            token=get_cookie('cart');
      }
      while(token == undefined);

      var myshopify_domain='felix-fetch.myshopify.com'
      try { 
        var ga_linker = ga.getAll()[0].get('linkerParam') 
      } catch(err) {
       var ga_linker ='';
      }
      var customer_param = '{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}';

      return "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token="+token+"&"+ga_linker+"&"+customer_param;
  }
  
  
  
});